import axios from '@/axios';
import { successToast, errorToast } from '@/utils/toast';
import Vue from 'vue';
import store from '@/store/store';

var theApi = {
  methods: {
    makeCall(show_loader, url, method, data, successTitle, showError, errorTitle) {
      const appLoading = document.getElementById('loading-bg');
      if (show_loader) appLoading.style.display = 'block';

      const self = new Vue();
      const login_type = localStorage.getItem('login_type');
      let baseUrl = $vjeConfig.VUE_APP_API_URL;

      if (url === 'experiences/activities/save' || url === 'experiences/activities/uploadFile') {
        baseUrl = baseUrl + 'student';
      } else if (login_type !== null && url != 'teacher/loginAs') baseUrl = baseUrl + login_type;

      if (baseUrl.substr(baseUrl.length - 1) !== '/') baseUrl = baseUrl + '/';
      //store.commit('isActiveApiCall', true);
      return new Promise((resolve, reject) => {
        axios({
          method: method,
          url: baseUrl + url,
          data: data,
        }).then(
          (response) => {
            //store.commit('isActiveApiCall', false);
            const responseData = response.data;
            if (typeof responseData.status === 'undefined' || responseData.status == 'OK') {
              if (
                typeof successTitle !== 'undefined' &&
                successTitle !== null &&
                successTitle !== '' &&
                successTitle.length > 0
              ) {
                self.$toast.success(successTitle || 'Item saved successfully!', successToast());
              }
              if (show_loader) appLoading.style.display = 'none';
              resolve(responseData);
            } else {
              if (typeof showError !== 'undefined' && showError) {
                self.$toast.error(
                  errorTitle || responseData.message || 'Something went wrong, please try again.',
                  errorToast(),
                );
              }
              if (show_loader) appLoading.style.display = 'none';
              reject();
            }
          },
          (response) => {
            //store.commit('isActiveApiCall', false);
            if (response.response.status == 401) {
              //User not logged in
              if (
                typeof response.response.data.type === 'undefined' ||
                response.response.data.type == 'NOT_LOGGED_IN'
              ) {
                if (login_type == 'student') {
                  localStorage.removeItem('token');
                  localStorage.removeItem('login_type');
                  localStorage.removeItem('fname');
                  localStorage.removeItem('lname');
                  store.commit('authStudent/setUser', {
                    userID: '',
                    token: '',
                    email: '',
                    fname: '',
                    lname: '',
                    prework: false,
                    activeVJE: false,
                    ctWhsEnabled: true,
                  });
                  window.location.href = '/student/login';
                } else if (login_type == 'teacher') {
                  localStorage.removeItem('token');
                  localStorage.removeItem('login_type');
                  localStorage.removeItem('fname');
                  localStorage.removeItem('lname');
                  store.commit('authTeacher/setUser', {
                    token: '',
                    email: '',
                    fname: '',
                    lname: '',
                  });
                  window.location.href = '/teacher/login';
                }
              } else if (response.response.data.type == 'TOKEN_EXPIRED') {
                store.commit('popup/setSessionTimeoutPopupVisible', true);
              }
            }
            const responseData = response.response.data;
            if (typeof showError !== 'undefined' && showError) {
              self.$toast(
                errorTitle || responseData.message || 'Something went wrong, please try again.',
              );
            }
            if (show_loader) appLoading.style.display = 'none';
            reject();
          },
        );
      });
    },
  },
};

export default theApi;
